import styled from '@emotion/styled';

export const Wrapper = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
`;

export const Content = styled.div`
  position: absolute;
  width: 500px;
  height: 305px;
  background: white;
  border-radius: 3px;
  box-shadow: 0px 11px 27px rgba(0, 0, 0, 0.2);
  padding: 60px;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ContentWrapper = styled.div`
  white-space: pre-wrap;
  color: #000000;
  font-size: 16px;
  line-height: 20px;
`;

export const ActionWrapper = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  text-align: center;
  vertical-align: middle;
  margin-top: 20px;
`;
export const StartMeeting = styled.button`
  width: 160px;
  height: 40px;
  background: #4bb5ce;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

export const CancelMeeting = styled.button`
  width: 160px;
  height: 40px;
  background: #2e303c;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;
